import * as actionType from './actionsTypes';

const initialState = {
    f_productName: '',
    f_bookingDate: { startDate: '', endDate: '' },
    f_programName: [],
    f_tsize: '',
    f_userName: '',
    f_camperName: '',
    f_email: '',
    f_status: ''

}

const allProductFilterStateReducer = (state = initialState, action) => {

    switch (action.type) {
        case actionType.F_PRODUCT_NAME_FILTER: return {...state, f_productName: action.payload}
        case actionType.F_BOOKING_DATE_FILTER: return {...state, f_bookingDate: action.payload}
        case actionType.F_PROGRAM_NAME: return {...state, f_programName: action.payload}
        case actionType.F_T_SIZE_FILTER: return {...state, f_tsize: action.payload}
        case actionType.F_USER_NAME_FILTER: return {...state, f_userName: action.payload}
        case actionType.F_CAMPER_NAME_FILTER: return {...state, f_camperName: action.payload}
        case actionType.F_EMAIL_FILTER: return {...state, f_email: action.payload}
        case actionType.F_STATUS_FILTER: return {...state, f_status: action.payload}
        default: return state;
    }
}

export const fProductNameFilterAction = payload => (dispatch => dispatch({ type: actionType.F_PRODUCT_NAME_FILTER, payload }))
export const fBookingDateFilterAction = (e) => (dispatch) => {
  if (Array.isArray(e) && e.length === 2) {
    dispatch({
      type: actionType.F_BOOKING_DATE_FILTER,
      payload: {
        startDate: e[0] ? e[0].valueOf() : '', // stores as timestamp in millis
        endDate: e[1] ? e[1].valueOf() : ''
      },
    });
  } else {
    dispatch({
      type: actionType.F_BOOKING_DATE_FILTER,
      payload: { startDate: '', endDate: '' },
    });
  }
};
export const fTsizeFilterAction = payload => (dispatch => dispatch({ type: actionType.F_T_SIZE_FILTER, payload }))
export const fUserNameFilterAction = payload => (dispatch => dispatch({ type: actionType.F_USER_NAME_FILTER, payload }))
export const fCamperNameFilterAction = payload => (dispatch => dispatch({ type: actionType.F_CAMPER_NAME_FILTER, payload }))
export const fEmailFilterAction = payload => (dispatch => dispatch({ type: actionType.F_EMAIL_FILTER, payload }))
export const fProgramNameFilterAction = payload => (dispatch => dispatch({ type: actionType.F_PROGRAM_NAME, payload }))
export const fStatusFilterAction = payload => (dispatch => dispatch({ type: actionType.F_STATUS_FILTER, payload }))

export default allProductFilterStateReducer;